"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get GetWorkflowDetailsResponse () {
        return GetWorkflowDetailsResponse;
    },
    get ListWorkflowDetailTodosResponse () {
        return ListWorkflowDetailTodosResponse;
    },
    get ListWorkflowTodosResponse () {
        return ListWorkflowTodosResponse;
    },
    get ListWorkflowsResponse () {
        return ListWorkflowsResponse;
    },
    get UpdateWorkflowArchivedResponse () {
        return UpdateWorkflowArchivedResponse;
    },
    get WORKFLOW_DETAIL_TODO_MEMBER_STATUSES () {
        return WORKFLOW_DETAIL_TODO_MEMBER_STATUSES;
    },
    get WORKFLOW_DETAIL_TODO_STATUSES () {
        return WORKFLOW_DETAIL_TODO_STATUSES;
    },
    get WORKFLOW_TODO_STATUSES () {
        return WORKFLOW_TODO_STATUSES;
    },
    get WorkflowDetailTodoMemberStatusSchema () {
        return WorkflowDetailTodoMemberStatusSchema;
    },
    get WorkflowDetailTodoStatusSchema () {
        return WorkflowDetailTodoStatusSchema;
    },
    get WorkflowTodoStatusCounts () {
        return WorkflowTodoStatusCounts;
    },
    get WorkflowTodoStatusSchema () {
        return WorkflowTodoStatusSchema;
    }
});
const _zod = require("zod");
const _responsehelpers = require("../helpers/response-helpers");
const WorkflowSubjectResponse = _zod.z.object({
    _id: _responsehelpers.ResponseObjectId,
    name: _zod.z.string()
});
const WorkflowResponseItem = _zod.z.object({
    _id: _responsehelpers.ResponseObjectId,
    name: _zod.z.string(),
    startDate: _zod.z.date(),
    subject: WorkflowSubjectResponse.nullable(),
    totalTodoCount: _zod.z.number().int(),
    completedTodoCount: _zod.z.number().int(),
    overdueTodoCount: _zod.z.number().int(),
    unassignedTodoCount: _zod.z.number().int(),
    completed: _zod.z.boolean()
});
const ListWorkflowsResponse = _zod.z.object({
    workflows: _zod.z.array(WorkflowResponseItem),
    totalCount: _zod.z.number().int()
});
const WORKFLOW_TODO_STATUSES = [
    "active",
    "completed",
    "overdue"
];
const WorkflowTodoStatusSchema = _zod.z.enum(WORKFLOW_TODO_STATUSES);
const WorkflowTodoReferenceResponse = _zod.z.object({
    _id: _responsehelpers.ResponseObjectId,
    name: _zod.z.string()
});
const WorkflowTodoResponseItem = _zod.z.object({
    _id: _responsehelpers.ResponseObjectId,
    action: _zod.z.string(),
    subject: WorkflowTodoReferenceResponse.nullable(),
    actor: WorkflowTodoReferenceResponse.nullable(),
    workflow: WorkflowTodoReferenceResponse.nullable(),
    dueDate: _zod.z.date(),
    completedDate: _zod.z.date().nullable(),
    status: WorkflowTodoStatusSchema
});
const ListWorkflowTodosResponse = _zod.z.object({
    todos: _zod.z.array(WorkflowTodoResponseItem),
    totalCount: _zod.z.number().int()
});
const WORKFLOW_DETAIL_TODO_STATUSES = [
    "incomplete",
    "awaiting_signatures",
    "completed",
    "overdue"
];
const WorkflowDetailTodoStatusSchema = _zod.z.enum(WORKFLOW_DETAIL_TODO_STATUSES);
const WORKFLOW_DETAIL_TODO_MEMBER_STATUSES = [
    "incomplete",
    "completed",
    "overdue"
];
const WorkflowDetailTodoMemberStatusSchema = _zod.z.enum(WORKFLOW_DETAIL_TODO_MEMBER_STATUSES);
const WorkflowTodoStatusCounts = _zod.z.object({
    completed: _zod.z.number().int(),
    overdue: _zod.z.number().int(),
    awaitingSignatures: _zod.z.number().int(),
    incomplete: _zod.z.number().int()
});
const GetWorkflowDetailsResponse = _zod.z.object({
    _id: _responsehelpers.ResponseObjectId,
    name: _zod.z.string(),
    startDate: _zod.z.date(),
    subject: WorkflowSubjectResponse.nullable(),
    archived: _zod.z.boolean(),
    totalTodoCount: _zod.z.number().int(),
    todoStatusCounts: WorkflowTodoStatusCounts
});
/**
 * One signer of a multi-assignee signature request, shown when its row is expanded.
 * `status` is the signer's own state — never `awaiting_signatures`, which describes the
 * request as a whole and belongs on the row above them.
 */ const WorkflowDetailTodoMember = _zod.z.object({
    _id: _responsehelpers.ResponseObjectId,
    actor: WorkflowTodoReferenceResponse.nullable(),
    dueDate: _zod.z.date(),
    completedDate: _zod.z.date().nullable(),
    done: _zod.z.boolean(),
    status: WorkflowDetailTodoMemberStatusSchema
});
const WorkflowDetailTodoResponseItem = _zod.z.object({
    _id: _responsehelpers.ResponseObjectId,
    action: _zod.z.string(),
    actor: WorkflowTodoReferenceResponse.nullable(),
    dueDate: _zod.z.date(),
    completedDate: _zod.z.date().nullable(),
    status: WorkflowDetailTodoStatusSchema,
    done: _zod.z.boolean(),
    hasSignatureRequest: _zod.z.boolean(),
    /**
	 * The attached signature request's id, used to link the to-do to its signing page.
	 * Present whenever `hasSignatureRequest` is true, including when the request itself
	 * can no longer be resolved — unlike `signatureRequest` below, this comes straight
	 * off the to-do rather than from a join.
	 */ signatureRequestId: _responsehelpers.ResponseObjectId.nullable(),
    /**
	 * Signer to-dos collapsed into this row. 1 for an ordinary to-do; the signing wizard
	 * creates one to-do per signer, and they are grouped into a single row.
	 */ assigneeCount: _zod.z.number().int(),
    /** How many of those signers are done — the "1 of 3 Complete" counter. */ completedCount: _zod.z.number().int(),
    /** The individual signers, in signing order. Empty unless assigneeCount > 1. */ members: _zod.z.array(WorkflowDetailTodoMember),
    /**
	 * The attached signature request, for the edit modal's read-only summary. Null when
	 * `hasSignatureRequest` is false, and also when it is true but the request no longer
	 * resolves — the join is the source of truth here, `signatureRequestId` above is the
	 * one that survives a dangling reference. `signerCount` counts resolved signers only,
	 * so it matches the `awaiting_signatures` status derivation.
	 */ signatureRequest: _zod.z.object({
        name: _zod.z.string(),
        signerCount: _zod.z.number().int(),
        completed: _zod.z.boolean(),
        completedDocumentId: _responsehelpers.ResponseObjectId.nullable()
    }).nullable()
});
const ListWorkflowDetailTodosResponse = _zod.z.object({
    todos: _zod.z.array(WorkflowDetailTodoResponseItem),
    totalCount: _zod.z.number().int()
});
const UpdateWorkflowArchivedResponse = _zod.z.object({
    _id: _responsehelpers.ResponseObjectId,
    archived: _zod.z.boolean()
});
